import { StopListTab } from "features/StopList/types";

export const STOP_LIST_PAGE_SIZE = 20;

// В диалоге список прокручивается, а не листается страницами, поэтому размер больше:
// на 30 строках догрузка успевает отработать до того, как пользователь упрётся в конец.
export const PICKER_PAGE_SIZE = 30;

export const SEARCH_DEBOUNCE_MS = 300;

export const DEFAULT_STOP_LIST_TAB: StopListTab = "items";

export const STOP_LIST_TAB_KEYS: StopListTab[] = ["items", "categories"];
